// extracted by mini-css-extract-plugin
module.exports = {"root":"Message_root__3S7uo","default":"Message_default__Nobe5","danger":"Message_danger__2ZHzp"};